import React from 'react';
import styles from '../css/comuns/DivisorSecao.module.css';
import { config } from '../../data';

const DivisorSecao = () => {
  return (
    <div className={styles['divisor-secao']}>
      <div className={styles['bolinhas-divisor']}></div>
      <h3>{config.texts.divisorSecao.titulo}</h3>
    </div>
  );
};

export default DivisorSecao;